import { TurboMountController } from "turbo-mount"

export default class ReactMountController extends TurboMountController {
  connect() {
    if (this.isPermanent()) return

    super.connect()
  }

  disconnect() {
    if (this.isPermanent()) return

    super.disconnect()
  }

  /**
   * Doesn't unmount/remount if parent or element has
   * `data-turbo-permanent` set.
   *
   * Specifically, keeps components sticky during Turbo navigation.
   *
   * @returns {boolean}
   */
  isPermanent() {
    if (
      "turboPermanent" in this.parentElementDataset ||
      "turboPermanent" in this.element.dataset
    ) {
      return true
    }
  }

  get parentElementDataset() {
    return this.element.parentElement?.dataset || {}
  }
}
